import { ButtonSize, PrimaryButton, Typography } from '@uni-of-exeter/digital.lib.react.ui.kit';
import { useBreakpoint } from '../../hooks/utils/use-breakpoint';
import { BannerData } from './types';
import '../styles/info-banner.css';
import { logEvent } from 'firebase/analytics';
import { analytics } from '../../firebase';
import { useAuthContext } from '../../auth';

interface InfoBannerProps {
  onClose: () => void;
  bannerData: BannerData
}

const handleBannerInfoBtn = (url?: string, userId?: string) => {

  if (url) {
    logEvent(analytics, 'banner_info_button_click', {
          banner_url: url,
          custom_user_id: userId,
        });
    window.open(url, '_blank');
  }
}

export function InfoBanner({ onClose, bannerData }: Readonly<InfoBannerProps>) {
  const isMobile = useBreakpoint('md', 'down');
  const { userId } = useAuthContext();
  return (
    <div id='infoBannerContainer'>
      <div id='infoBannerContent'>
        <div id='infoBannerTextContainer'>
          <Typography
            id='infoBannerHeading'
            variant="h5"
            fontWeight={isMobile ? 500 : 700}
            fontSize={isMobile ? '0.825rem' : undefined}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M14.8234 2.39999L16.6537 7.3462L21.5999 9.17646L16.6537 11.0067L14.8234 15.9529L12.9932 11.0067L8.04696 9.17646L12.9932 7.3462L14.8234 2.39999Z" stroke="#003C3C" strokeWidth="2" strokeLinejoin="round" />
              <path d="M6.35284 13.6941L7.95167 16.0482L10.3058 17.6471L7.95167 19.2459L6.35284 21.6L4.75402 19.2459L2.3999 17.6471L4.75402 16.0482L6.35284 13.6941Z" stroke="#003C3C" strokeWidth="2" strokeLinejoin="round" />
            </svg> 
            {bannerData.bannerHeading}
          </Typography>
          <Typography id='infoBannerText' variant="body.small">{bannerData.bannerBody}</Typography>
        </div>
        { bannerData.button?.buttonText && bannerData.button?.buttonDestination && (
        <div id='infoBannerButtonContainer'>
          <PrimaryButton
            className="button"
            aria-label={bannerData.button?.buttonText}
            buttonSize={ButtonSize.Large}
            onClick={() => { handleBannerInfoBtn(bannerData.button?.buttonDestination, userId) }}
          >
            {bannerData.button?.buttonText}
          </PrimaryButton>
        </div>)}

      </div>
      <button id='infoBannerCloseButton' onClick={onClose}>
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
          <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="#003C3C" />
        </svg>
      </button>
    </div>
  );
}
